import React, { Component } from 'react';
import DimensionMemberSelector from '../DimensionMemberSelector';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export default class NominalChange extends Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "nominalChangeOver": "",
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dataSource": "",
            "connectionName": "",
            "trend": {
                "name": "Nominal Change",
                "type": 1,
                "baseValue": null,
                "isBaseDisplayed": false,
                "useAllOthersCalculation": false,
                "treatNullAsZero": false,
                "slicers": [],
                "selectors": [],
                "active": true,
                "referenceOnly": false,
                "showSlicers": true,
                "userFormat": ""
            },
            "dimensions": [],
            "globals": []
        };
    }
    componentDidMount() {
        let trend = { "selectors": [] }
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let connectionName = ""
        let dimensions = []
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.trend !== undefined) { trend = this.props.trend; }
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
        if (this.props.globals !== undefined) { globals =  this.props.globals }

        this.initSetOriginalSelectorDimension(dimensions, trend)
        this.setState({ trend, chartId, connectionId, allConnectionIds, dataSource, connectionName, dimensions, globals })
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let trend = { "selectors": [] }
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let connectionName = ""
        let dimensions = []
        let globals = []

        let previousSlicers = prevProps.trend.slicers;
        let newSlicers = this.props.trend.slicers;

        let previousSelectors = prevProps.trend.selectors;
        let newSelectors = this.props.trend.selectors;

        if (prevProps.chartId !== this.props.chartId) {
            // Read in the props passed in from the parent
            if (this.props.trend !== undefined) { trend = this.props.trend; }
            if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
            if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
            if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
            if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
            if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
            if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
            if (this.props.globals !== undefined) { globals =  this.props.globals }

            this.initSetOriginalSelectorDimension(dimensions, trend);
            this.setState({ trend, chartId, connectionId, allConnectionIds, dataSource, connectionName, dimensions, globals });
        } else if (previousSlicers.length !== newSlicers.length ||
            previousSelectors.length !== newSelectors.length ||
            this.props.editorUpdates !== prevProps.editorUpdates) {
            this.initSetOriginalSelectorDimension(this.props.dimensions, this.props.trend);
            this.setState({ trend: this.props.trend });
        }
    }
    render() {
        return <div>
            <div style={{ textAlign: "left" }}>
                <h5 className="mainLable">Nominal Change Over:</h5>
                <Select
                    className="myInput"
                    onChange={(e) => this.handleNominalChange(e, this.state.trend, this.state.dimensions)}
                    value={this.state.nominalChangeOver}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value=""></MenuItem>
                    {this.state.dimensions.map((dimension) => {
                        return <MenuItem key={`dimension-${dimension.typeOfDimension}`} value={dimension.alias}>{dimension.alias}</MenuItem>;
                    })}
                </Select>
                <table style={{ "width": "100%", "margin": "15px 0px 0px" }}>
                    {this.renderSelectorsTable(this.state.trend, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.chartId, this.state.connectionName, this.state.globals)}
                </table>
                <div style={{ "textAlign": "left", "margin": "25px 0px 0px" }}>Additional Selections:</div>
                <table style={{ "width": "100%" }}>
                    {this.renderSlicerTable(this.state.trend, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.chartId, this.state.connectionName)}
                </table>
            </div>
        </div>;
    }
    //#endregion

    //#region Event Handlers
    handleNominalChange = (event, trend, dimensions) => {
        event.preventDefault();

        let selectedNewValue = event.target.value;
        if (selectedNewValue !== "") {
            dimensions.forEach(dimension => {
                if (dimension.alias === selectedNewValue) {
                    trend.selectors = [{
                        "dimensionAlias": dimension.alias,
                        "dimensionSystemName": dimension.systemName,
                        "typeOfDimension": dimension.typeOfDimension,
                        "prefix": "",
                        "suffix": "",
                        "items": [{ "caption": "" }, { "caption": "" }],
                        "attributes": []
                    }];
                } else {
                    trend.slicers = [{
                        "dimensionAlias": dimension.alias,
                        "dimensionSystemName": dimension.systemName,
                        "typeOfDimension": dimension.typeOfDimension,
                        "prefix": "",
                        "suffix": "",
                        "items": [{ "caption": "" }],
                        "attributes": []
                    }];
                }
            });

            this.setState({ nominalChangeOver: selectedNewValue, trend: trend });
        }

    };
    //#endregion

    //#region Data Handlers
    initSetOriginalSelectorDimension = (dimensions, trend) => {
        // Putting in the selected dropdown if we have a selector
        let selectorDimensionAlias = "";

        if (trend.selectors.length > 0) {
            let firstSelector = trend.selectors[0];
            selectorDimensionAlias = firstSelector.dimensionAlias;
        }

        this.setState({ nominalChangeOver: selectorDimensionAlias });
    };
    updateSlicerData = (selections, dimensionAlias) => {
        let trend = this.state.trend;

        trend.slicers.forEach(s => {
            if (s.dimensionAlias === dimensionAlias) {
                s.items = selections;
            }
        });

        if (this.props.onSelectionChange) { this.props.onSelectionChange(trend); }
        this.setState({ trend });
    };
    updateSelectorData = (selections, dimensionAlias, itemIndex) => {
        let trend = this.state.trend;

        if (trend.selectors.length > 0) {
            for (let x = 0; x < trend.selectors[0].items.length; x++) {
                if (x === itemIndex) {
                    trend.selectors[0].items[x] = selections[0];
                }
            }
        }

        if (this.props.onSelectionChange) { this.props.onSelectionChange(trend); }
        this.setState({ trend });
    };
    //#endregion

    //#region Render Methods
    renderSelectorsTable = (trend, connectionId, allConnectionIds, dataSource, chartId, connectionName, globals) => {
        let rtnArr = [];

        trend.selectors.map((selector, selectorIndex) => {
            selector.items.map((item, itemIndex) => {
                let selectedItem = { "caption": "", "isSelected": true };

                if (item === undefined) {
                    selectedItem = { "caption": "", "isSelected": true };
                } else {
                    selectedItem = item;
                }

                rtnArr.push(
                    <tbody key={`selector-${selectorIndex}-${itemIndex}`}>
                        <tr>
                            <td style={{ "textAlign": "left", "width": "10%", "minWidth": "125px" }}>{selector.dimensionAlias}</td>
                            <td style={{ "textAlign": "left", "width": "25%", "minWidth": "330px" }}>{selectedItem.caption}</td>
                            <td style={{ "textAlign": "left" }}>
                                <DimensionMemberSelector
                                    multiSelect={false}
                                    chartId={chartId}
                                    dimensionAlias={selector.dimensionAlias}
                                    connectionId={connectionId}
                                    allConnectionIds={allConnectionIds}
                                    dataSource={dataSource}
                                    selections={[selectedItem]}
                                    connectionName={connectionName}
                                    globals={globals}
                                    onSelectionChange={(selections, dimensionAlias) => this.updateSelectorData(selections, dimensionAlias, itemIndex)}
                                />
                            </td>
                        </tr>
                    </tbody>
                );
            });
        });

        return rtnArr;
    };
    renderSlicerTable = (trend, connectionId, allConnectionIds, dataSource, chartId, connectionName) => {
        let rtnArr = [];

        trend.slicers.map((slicer, index) => {
            let selectedItem = { "caption": "", "isSelected": true };
            let items = slicer.items;

            items.forEach(item => {
                if (item.isSelected) { selectedItem = item; }
            });

            rtnArr.push(
                <tbody key={`slicer-${index}`}>
                    <tr>
                        <td style={{ "textAlign": "left", "width": "10%", "minWidth": "125px" }}>{slicer.dimensionAlias}</td>
                        <td style={{ "textAlign": "left", "width": "25%", "minWidth": "330px" }}>{selectedItem.caption}</td>
                        <td style={{ "textAlign": "left" }}>
                            <DimensionMemberSelector
                                multiSelect={false}
                                chartId={chartId}
                                dimensionAlias={slicer.dimensionAlias}
                                connectionId={connectionId}
                                allConnectionIds={allConnectionIds}
                                dataSource={dataSource}
                                selections={slicer.items}
                                connectionName={connectionName}
                                onSelectionChange={(selections, dimensionAlias) => this.updateSlicerData(selections, dimensionAlias)}
                            />
                        </td>
                    </tr>
                </tbody>
            );
        });

        return rtnArr;
    };
    //#endregion
}